import React from 'react';
import { Tooltip } from '@mui/material';
import { Report as WarningIcon } from '@mui/icons-material';
import { NotificationType, GroupForListType } from '../types';
import { COLOR_BLUE } from '../theme';

function TenantNameLink({
    id,
    name,
    isRejected,
    isCarrier,
    unqualified
}: {
    id?: number | string | null,
    name: React.ReactNode,
    isRejected?: boolean | null,
    isCarrier?: boolean | null,
    unqualified?: boolean
}) {
    return (
        <>
            {unqualified && isCarrier && (
                <Tooltip title="Detta företag uppfyller inte alla krav för uppdraget.">
                    <WarningIcon
                        color="error"
                        sx={{
                            fontSize: '18px',
                            verticalAlign: 'text-bottom',
                            marginRight: 0.5
                        }}
                    />
                </Tooltip>
            )}
            {id && !isRejected && isCarrier ? (
                <a
                    href={`/company-profile/${id}`}
                    target="_blank"
                    style={{ color: COLOR_BLUE }}
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                >
                    {name}
                </a>
            ) : name}
        </>
    );
}

export const getTenantLinkForJobsOffers = (entity: any) => (
    <TenantNameLink
        id={entity.tenantId}
        name={entity.tenantName}
        isRejected={entity.isRejected}
        isCarrier={entity.isCarrier}
        unqualified={entity.offeringPartyQualified === false}
    />
);

export const getTenantLinkForActiveOffers = (entity: any) => (
    <TenantNameLink
        id={entity.tenantIdForLinks}
        name={entity.tenantName}
        isRejected={entity.isRejected}
        isCarrier={entity.isCarrier}
        unqualified={entity.offeringPartyQualified === false}
    />
);

export const getTenantLinkForOrders = (order: any) => (
    <TenantNameLink
        id={order.acceptedTenantId}
        name={order.acceptedTenantName}
        isRejected={order.acceptedTenantIsRejected}
        isCarrier={order.acceptedTenantIsCarrier}
    />
);

export const getTenantLinkForNotifications = (notification: NotificationType) => (
    <TenantNameLink
        id={notification.tenantId}
        name={notification.tenantName}
        isRejected={notification.isRejected}
        isCarrier={notification.isCarrier}
        unqualified={notification.offeringPartyQualified === false}
    />
);

export const getTenantLinkForGroups = (group: GroupForListType) => (
    <TenantNameLink
        id={group.ownerTenantId}
        name={group.ownerTenantName}
        isRejected={group.isRejected}
        isCarrier={group.isCarrier}
    />
);
